import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import RouteManager, { PAGE_ROUTES } from "../../../../managers/RouteManager";
import Utility, { deepClone } from "../../../../utility/Utility";
import { US_FORM_FIELDS, IRAS_FORM_TYPE, MANDATORY_FIELDS_FORMS } from "./SGReportsConstant";
import ic_arrow_back from "../../../../assets/icons/ic_arrow_back.svg";
import {
    DKTooltipWrapper, DKIcon, DKLabel, DKInput, DKButton, DKLine, DKSpinner, TOAST_TYPE,
    showToast, showAlert
} from "deskera-ui-library";
import { CONSTANTS, CPFMonth, INPUT_TYPE } from "../../../../constants/Constant";
import ReportService from "../../../../services/ReportService";
import EmployeeListService from "../../../../services/EmployeeListService";
import { fetchCPFAccount, selectCPFAccounts, selectEmployeeListWithoutLimit, fetchEmployeeListWithoutFilter } from "../../../../Redux/Slices/EmployeeListSlice";
import { getIRASReportYears, getFileNameFromContentDisposition } from "../../../../managers/common/CommonUtil"
import { saveAs } from 'file-saver';
import { TENANT, TenantService } from "../../../../managers/TenantManagerService";
import EditAppendix8AForm from "./EditAppendix8AForm";
import IR8AForm from "./IR8AForm";
import IRASService from "../../../../services/IRASService";
import { deleteFormEmployeeDetails } from "../../../../Redux/Slices/SGFormsSlice";
import EditIR8SForm from "./EditIR8SForm";
import Appendix8BForm from "./Appendix8BForm";
import TenantManager from "../../../../managers/TenantManager";

const SGDefaultForms = (props) => {
    const isModule = props?.location?.state?.module? true: false;
    const report = isModule ? props.location.state.module : CONSTANTS.EMPTY_STRING;
    const isSource = props?.location?.state?.source? true: false;
    const source = isSource ? props.location.state.source : CONSTANTS.EMPTY_STRING;;

    /**Selectors**/
    const cpfAccountDetails = useSelector(selectCPFAccounts);
    const employeeDetails = useSelector(selectEmployeeListWithoutLimit);

    /**Hooks**/
    const [formConfig, setFormConfig] = useState(ReportService.getFormConfig(report));
    const [firstSection, setFirstSection] = useState(formConfig?.FIRST_SECTION || []);
    const [secondSection, setSecondSection] = useState(formConfig?.SECOND_SECTION || []);
    const [formValues, setDefaultValues]  = useState({});
    const [formYears, setFormYears] = useState(getIRASReportYears());
    const [cpfMonth, setCpfMonth] = useState(CPFMonth);
    const [appendix8AFormEdit, setAppendix8AFormEdit] = useState(false);
    const [enableIR8AForm, setIR8AFormVisibility] = useState(false);
    const [ir8aformDetails, setIR8AFormDetails] = useState({});
    const [editIR8SForm, setEditIR8SForm] = useState(false);
    const [enableAppendix8AForm, setAppendix8AFormVisibility] = useState(false);
    const [appendix8BFormDetails, setAppendix8BFormDetails]=useState({});


    /**Dispatch**/
    const dispatch = useDispatch();

    useEffect(() => {
        RouteManager.setPresenter({props: props});
        if(Utility.isEmptyObject(formConfig)) {
            routeToOrigin();  
        }
        loadCPFAccountDetails();
        loadEmployee({
            customJson:{
                "orderBy.field": "updatedAt",
                "orderBy.order": "desc",
              }
          });

          window.navigateToPage = (url) => {
            document.getElementById("dk-alert-background")?.remove();
            document.getElementById("dk-alert")?.remove();
            switch (url) {            
                default:
                    RouteManager.navigateToPage(url);
                    break;
            }
            
        }
    },[]);

    useEffect(() => {
        prepareExternalOptionsData();

    },[cpfAccountDetails, employeeDetails])

    const prepareExternalOptionsData = () => {
        const formFields = US_FORM_FIELDS[report];
        const sectionOne = deepClone(firstSection);
        const alteredConfig = [];
        formFields?.forEach(field => {
            switch(field) {
                case "cpfAccount":
                    let cpfOptions = [];
                    if(cpfAccountDetails?.accounts?.length > 0) {
                        let accounts = cpfAccountDetails.accounts.map((account) => {
                            return {
                              id: account.accountId,
                              name: account?.compliance?.name,
                              accountType: account.accountType,
                              compliance: account.compliance,
                            };
                        });
                        cpfOptions =  accounts;
                    }
                    alteredConfig.push({columnCode:"cpfAccount", options: cpfOptions});
                    break; 
                case "year":
                    const currentYear = new Date().getFullYear();
                    const yearValue = EmployeeListService.getValueObjectFromDropdown(currentYear, formYears, "id");
                    if (!Utility.isEmptyObject(yearValue)) formValues["year"] = yearValue;
                    alteredConfig.push({columnCode:"year", options: formYears});
                    break;
                case "month":
                    const currentMonth = new Date().getMonth() + 1;
                    const monthValue = EmployeeListService.getValueObjectFromDropdown(currentMonth, cpfMonth, "id");
                    if (!Utility.isEmptyObject(monthValue)) formValues["month"] = monthValue;
                    alteredConfig.push({columnCode:"month", options: cpfMonth});
                    break;
                case "employee":
                    let employeeOptions = [];
                    if(employeeDetails?.users?.length > 0) {
                        let employees = employeeDetails.users.map((user) => {
                            return {
                              id: user.userId,
                              name: `${user.firstName} ${user.lastName}`,
                              compliance: user?.compliance,
                              assignedCpfAccount: user?.compliance?.assignCPFAccount,
                              ...user
                            };
                        });
                        employeeOptions =  employees;
                    }
                    alteredConfig.push({columnCode:"employee", options: employeeOptions}); 
                    break;
                case "formType":
                    formValues["formType"] = IRAS_FORM_TYPE[0];
                    alteredConfig.push({columnCode:"formType", options: IRAS_FORM_TYPE});
                    break;
            } 
        });
        EmployeeListService.getAlteredConfigDetails(
            sectionOne,
            alteredConfig,
            false,
            {},
            {}
        );
        setFirstSection(sectionOne);
    }

    const loadCPFAccountDetails = async () => {
        try {
          const config = {
            Limit: 100,
            currentPage: 1,
            order: undefined,
            field: undefined,
            searchString: undefined,
          };
          EmployeeListService.apiConfig = config;
          await dispatch(fetchCPFAccount());
        } catch (err) {
          console.error("Error loading custom fields data: ", err);
        }
      };

    const loadEmployee = async (config) => {
        try {
            EmployeeListService.apiConfig = config;
            await dispatch(fetchEmployeeListWithoutFilter());
        } catch (err) {
            console.error('Error loading contacts: ', err);
        }
    };

    const routeToOrigin = () => {
        switch(source) {
            case "report-list":
                RouteManager.navigateToPage(PAGE_ROUTES.REPORTS_LIST);
                break;
            case "reports":
                RouteManager.navigateToPage(PAGE_ROUTES.REPORTS_LIST_NEW);
                break
            default:
                RouteManager.navigateToPage(PAGE_ROUTES.REPORTS_LIST);
        }
    }

    const getButtonAction = (field) => {
        switch(field.columnCode) {
            case "cpfSubmissionFile":
                onCPFSubmissionReportDownload();
                break;
            case "ir8aFormDownload":
            case "ir8sFormDownload":
            case "appendix8aDownload":
            case "appendix8aDownload":
                irasReportDownload(field);
                break;
            case "irasESubmissionDownload":
                irasSubmissionReportDownload(field);
                break;
            case "editAppendix8a":
                if(!isValidSubmission()) {
                    return;
                }
                setAppendix8AFormEdit({
                    cpfAccount: formValues['cpfAccount'].id,
                    employee: formValues['employee'],
                    year: formValues['year'].id
                });
                break;
            case "editIR8SForm":
                if(!isValidSubmission()) {
                    return;
                }
                setEditIR8SForm({
                    cpfAccount: formValues['cpfAccount'].id,
                    employee: formValues['employee'],
                    year: formValues['year'].id
                });
                break;

            case "editIR8AForm":
                getIR8AFormDetails(field,"IR8A");
                break;
            case "editAppendix8BForm":
                getAppendix8BFormDetails(field, "APPENDIX_8B");
                break;
        }
    }

    const getIR8AFormDetails = (field, formType) => {
        if(!isValidSubmission()) {
            return;
        }
        const formField = deepClone(secondSection);
        setSpinnerValue(formField, true, field.columnCode, true);
        const options = getFormParams(formType);
        const userId = EmployeeListService.getSelectedIdFromObject(formValues["employee"], "id")
        IRASService.getReportData(options, userId).then((response) => {
            if(response?.length > 0) {
                setIR8AFormDetails({userId: userId, formDetails: response });
                setSpinnerValue(formField, false, field.columnCode, false);
                setIR8AFormVisibility(true);
            } else {
                setSpinnerValue(formField, false, field.columnCode, false);
                showToast(`No ${formType} form to edit`, TOAST_TYPE.WARNING);
            }
        }, (error) => {
            setSpinnerValue(formField, false, field.columnCode, false);
            showToast(`Something went wrong`, TOAST_TYPE.ERROR)
        })
    }

    const getAppendix8BFormDetails = (field, formType) => {
        if(!isValidSubmission()) {
            return;
        }
        const formField = deepClone(secondSection);
        setSpinnerValue(formField, true, field.columnCode, true);
        const options = getAppendix8BFormParams(formType);
        const userId = EmployeeListService.getSelectedIdFromObject(formValues["employee"], "id")
        IRASService.getAppendix8BFormData(options, userId).then((response) => {
            if(response) {
                setAppendix8BFormDetails({userId: userId, formDetails: response });
                setAppendix8AFormVisibility(true);
                setSpinnerValue(formField, false, field.columnCode, false);
                
            } else {
                setSpinnerValue(formField, false, field.columnCode, false);
                showToast(`No Appendix 8B form to edit`, TOAST_TYPE.WARNING);
            }
        }, (error) => {
            setSpinnerValue(formField, false, field.columnCode, false);
            showToast(`Something went wrong`, TOAST_TYPE.ERROR)
        })
    }

    const getFormParams = (formType) => {
        let options = {
            year: EmployeeListService.getSelectedIdFromObject(formValues["year"], "id"),
            cpfAccountId: EmployeeListService.getSelectedIdFromObject(formValues["cpfAccount"], "id"),
            reportType: formType,
        }
        return options;
    }

    const getAppendix8BFormParams = () => {
        let options = {
            year: EmployeeListService.getSelectedIdFromObject(formValues["year"], "id"),
            cpfAccountNo: EmployeeListService.getSelectedIdFromObject(formValues["cpfAccount"], "id"),
        }
        return options;
    }

    const onCPFSubmissionReportDownload = () => {
        if(!isValidSubmission()) {
            return;
        }
        const formField = deepClone(secondSection);
        setSpinnerValue(formField, true, "cpfSubmissionFile", true);
        const options = {
            month: EmployeeListService.getSelectedIdFromObject(formValues["month"], "id"),
            year: EmployeeListService.getSelectedIdFromObject(formValues["year"], "id"),
            cpfAccount: EmployeeListService.getSelectedIdFromObject(formValues["cpfAccount"], "id")
        };

        ReportService.downloadCpfReport(options).then((response) => {
            const headers = response['headers'];
            const filename = getFileNameFromContentDisposition(headers['content-disposition']);
            saveAs(response.data, filename);
            const formField = deepClone(secondSection);
            setSpinnerValue(formField, false, "cpfSubmissionFile", false);
            showToast("Form downloaded successfully", TOAST_TYPE.SUCCESS);
        }, (error) => {
            const formField = deepClone(secondSection);
            setSpinnerValue(formField, false, "cpfSubmissionFile", false);
            showToast("Something went wrong", TOAST_TYPE.FAILURE);
        })
    }

    const irasReportDownload = (field) => {
        if(!isValidSubmission()) {
            return;
        }
        const formField = deepClone(secondSection);
        setSpinnerValue(formField, true, field.columnCode, true);
        const options = {
            year: EmployeeListService.getSelectedIdFromObject(formValues["year"], "id"),
            cpfAccount: EmployeeListService.getSelectedIdFromObject(formValues["cpfAccount"], "id")
        };
        const userId = EmployeeListService.getSelectedIdFromObject(formValues["employee"], "id")

        ReportService.downloadReport(options, userId, field.formName).then((response) => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const employeeId = EmployeeListService.getSelectedIdFromObject(formValues["employee"], "employeeId");
            const userName = EmployeeListService.getSelectedIdFromObject(formValues["employee"], "name");
            const filename = formConfig.FORM_DESCRIPTION + employeeId + '-' + userName + '.pdf';
            saveAs(response.data, filename);
            const formField = deepClone(secondSection);
            setSpinnerValue(formField, false, field.columnCode, false);
            showToast("Form downloaded successfully", TOAST_TYPE.SUCCESS);
        }, (error) => {
            const formField = deepClone(secondSection);
            setSpinnerValue(formField, false, field.columnCode, false);
            showToast("Something went wrong", TOAST_TYPE.FAILURE);
        })
    }

    const irasSubmissionReportDownload = (field) => {
        if(!isValidSubmission()) {
            return;
        }

        if(!isMandatoryFieldPresent()) {
            return;
        }

        const formField = deepClone(secondSection);
        setSpinnerValue(formField, true, field.columnCode, true);
        const options = {
            year: EmployeeListService.getSelectedIdFromObject(formValues["year"], "id"),
            cpfAccount: EmployeeListService.getSelectedIdFromObject(formValues["cpfAccount"], "id"),
            formType: EmployeeListService.getSelectedIdFromObject(formValues["formType"], "id"),
            authorizedUserId: TenantService.get(TENANT.USER_ID)
        };       

        ReportService.downloadIRASESubmissionReport(options).then((response) => {
            const blob = new Blob([response.data], { type: 'text/plain' });
            const year = EmployeeListService.getSelectedIdFromObject(formValues["year"], "id");
            const irasFormType = EmployeeListService.getSelectedIdFromObject(formValues["formType"], "id");
            const fileName = year + irasFormType + 'Esubmission.txt';
            saveAs(response.data, fileName);
            const formField = deepClone(secondSection);
            setSpinnerValue(formField, false, field.columnCode, false);
            showToast("Form downloaded successfully", TOAST_TYPE.SUCCESS);
        }, (error) => {
            const formField = deepClone(secondSection);
            setSpinnerValue(formField, false, field.columnCode, false);
            showToast("Something went wrong", TOAST_TYPE.FAILURE);
        })
    }

    const isValidSubmission = () => {
        let validationFields = US_FORM_FIELDS[report];
        let sectionOne = deepClone(firstSection);
        const alteredConfig= [];
        for(let field = 0; field < validationFields?.length; field++) {
            if(Utility.isEmpty(formValues[validationFields[field]]) || (typeof(formValues[validationFields[field]]) === "object" && Utility.isEmptyObject(formValues[validationFields[field]]))) {
                let config = {columnCode: validationFields[field], hasError: true};
                alteredConfig.push(config);
            }
        }
        if(!Utility.isEmpty(alteredConfig.length)) {
            EmployeeListService.getAlteredConfigDetails(sectionOne, alteredConfig, false, {}, {});
            setFirstSection(sectionOne);
            return false;
        }
        return true;

    }

    const isMandatoryFieldPresent = () => {
        let isFieldsPresent = true;
        const formType = EmployeeListService.getSelectedIdFromObject(formValues["formType"], "id");
        const requiredFields = [];

        const fields = MANDATORY_FIELDS_FORMS[formType];
        fields?.forEach(field => {
            switch (field) {
                case "Company Number":
                    const tenantData = TenantManager.getPeopleTenantData();
                    if(Utility.isEmpty(tenantData?.tenant?.contactNumber)) {
                        requiredFields.push({field: "Company Contact Number", url: PAGE_ROUTES.COMPANY_DETAILS});
                        isFieldsPresent = false;
                    }
                    break;
            
                default:
                    break;
            } 
        });
        if(!isFieldsPresent) {
            const buttons = [
                {
                  title: "Ok",
                  className: "bg-red text-white ml-r"
                },
              ];
    
            showAlert(
                `Please fill below details before proceeding further`,
                `<div class=''>${requiredFields.map((f,i) => `<div class='d-flex fs-s' style='justify-content:flex-start; padding-top:5px'><div class='fs-m cursor-hand' onclick=window.navigateToPage('${f.url}')><span class='fw-m'>${i + 1}.</span> <u class='text-app'>${f.field}</u></div></div>`).join('')}</div>`,
                buttons
              );
        }

        return isFieldsPresent;
    }

    const isValidEmployeeSelected = (employees, value) => {
        let isPresent = false;
        const selectedEmployee = EmployeeListService.getSelectedIdFromObject(value, "id");
        if(!Utility.isEmpty(selectedEmployee)) {
            let employeeObject = EmployeeListService.getValueObjectFromDropdown(selectedEmployee, employees, "userId");
            if(!Utility.isEmptyObject(employeeObject)) {
                isPresent = true;
            }

        }
        return isPresent;
    }

    const onValueChange = (value, object) => {
        let sectionOne = deepClone(firstSection);
        const alteredConfig= [];
        const formFields = US_FORM_FIELDS[report];
        switch(object.columnCode) {
            case "cpfAccount":
                if(Utility.isEmpty(value)) {
                    let config = {columnCode: object.columnCode, hasError: true};
                    alteredConfig.push(config);
                } else {
                    if(formFields.some(f => f === "employee")) {
                        const filteredEmployees = getSelectedCpfAccountEmployees(EmployeeListService.getSelectedIdFromObject(value, "id"));
                        const isValidEmployee = isValidEmployeeSelected(filteredEmployees, formValues["employee"]);
                        alteredConfig.push({columnCode: "employee", options: filteredEmployees, hasError: !isValidEmployee});
                        if (!isValidEmployee) formValues["employee"] = {};
                    }
                    alteredConfig.push({columnCode: object.columnCode, hasError: false});
                }
                break;
            default:
                if(Utility.isEmpty(value)) {
                    alteredConfig.push({columnCode: object.columnCode, hasError: true});
                } else {
                    alteredConfig.push({columnCode: object.columnCode, hasError: false});
                }
        }
        formValues[object.columnCode] = value;
        EmployeeListService.getAlteredConfigDetails(sectionOne, alteredConfig, false, {}, {});
        setFirstSection(sectionOne);
    }

    const getSelectedCpfAccountEmployees = (selectedAccount) => {
        const employeeData = deepClone(employeeDetails);
        const filteredUser = [];
        if(employeeData?.users?.length > 0) {
            employeeData.users.forEach(user => {
                if (user.compliance && user.compliance.assignCPFAccount) {
                    const accoundId = user.compliance.assignCPFAccount;
                    if (accoundId === selectedAccount) {
                        let object = {
                            id: user.userId,
                            name: `${user.firstName} ${user.lastName}`,
                            compliance: user?.compliance,
                            assignedCpfAccount: user?.compliance?.assignCPFAccount,
                            ...user
                          };
                        filteredUser.push(object);
                    }
                }
            });
        }
        return filteredUser;
    }

    const setSpinnerValue = (formField, value, fieldName, readOnly) => {
        const alteredConfig = [{columnCode: fieldName, isLoading: value, readOnly: readOnly}];
        EmployeeListService.getAlteredConfigDetails(formField, alteredConfig, false, {}, {});
        setSecondSection(deepClone(formField));
    }

    const closeIR8AForm = () => {
        dispatch(deleteFormEmployeeDetails())
        setIR8AFormVisibility(false)
    }

    const closeAppendix8BForm = () => {
        dispatch(deleteFormEmployeeDetails())
        setAppendix8AFormVisibility(false)
    }

    const getSections = (sectionData) => {
        return sectionData.map((obj, index) => {
            return(
                <>
                    {(obj.type === INPUT_TYPE.TEXT || obj.type === INPUT_TYPE.NUMBER || obj.type === INPUT_TYPE.DROPDOWN) && (
                        <div className="pr-l" style={{ width: "35%" }}>
                        <DKInput
                            title={obj.name}
                            value={formValues[obj.columnCode]}
                            formatter={(obj) => {
                                /** How to render a selected option in case of object **/
                                return obj.name;
                            }}
                            displayKey={obj.displayKey}
                            type={obj.type}
                            required={obj.required}
                            readOnly={obj.readOnly}
                            direction={obj.direction}
                            options={obj.options}
                            onChange={(value) => {
                                onValueChange(value,obj);
                            }}
                            dropdownConfig={{
                                className: "",
                                style: {},
                                allowSearch: obj.options?.length > 6,
                                searchableKey: obj.searchableKey,
                                data: obj.options,
                                renderer: (index, obj) => {
                                    /** How to render value in Dropdown in case of object **/
                                    return <DKLabel className="" text={obj.name} />;
                                },
                                onSelect: (index, value) => { },
                            }}
                            canValidate={obj.hasError}
                            validator={(value) => {
                                return !obj.hasError;
                            }}
                            errorMessage={obj.errMsg}
                        />
                    </div>
                    )}
                    {obj.type === INPUT_TYPE.BUTTON && obj.isButton && (
                        <>
                            <div className={`${obj.buttonConfig.buttonClass}`} style={{ marginTop: "" }}>
                                <DKButton
                                    title={obj.buttonConfig.title}
                                    icon={obj.buttonConfig.icon}
                                    className={`${obj.buttonConfig.className}`}
                                    onClick={() => {
                                        getButtonAction(obj);
                                    }}
                                    disabled={obj.readOnly}
                                />
                            </div>
                            {obj.isLoading && <DKSpinner className="pl-s" />}
                        </>
                    )}
                </>
            )
        })
    }

    const getCardSection = () => {
        return(
            <>
                <div className="bg-white pb-l card-shadow mt-l">
                    {!Utility.isEmptyObject(formConfig) && !Utility.isEmpty(formConfig.FORM_DESCRIPTION) && (
                        <DKLabel text={formConfig.FORM_DESCRIPTION} className="fw-m fs-l p-l" />
                    )}
                    <DKLine className="bg-gray3" />
                    <div className="d-flex p-h-l p-v-l">
                        {getSections(firstSection)}
                    </div>
                    <div className="d-flex p-h-l p-v-l">
                        {getSections(secondSection)}
                    </div>
                </div>
            </>
        )
    }

    const getHeaderSection = () => {
        return(
            <>
                <div className="d-flex align-items-center">
                    {!Utility.isEmptyObject(formConfig) && formConfig.BACK_BUTTON && (
                        <div onClick={() => routeToOrigin()}>
                            <DKTooltipWrapper
                                content="Back to Report list"
                                tooltipClassName="warning-tooltip-prop"
                            >
                                <DKIcon src={ic_arrow_back} className="ic-s mr-r cursor-hand" />
                            </DKTooltipWrapper>
                        </div>
                    )}
                    {!Utility.isEmptyObject(formConfig) && !Utility.isEmpty(formConfig.FORM_HEADING) && (
                        <DKLabel text={formConfig.FORM_HEADING} className="fw-m fs-l" />
                    )}
                </div>
            </>
        )
    }

    return(
        <>
            <div className="parent-width">
                {getHeaderSection()}
                {getCardSection()}
            </div>
            {appendix8AFormEdit && <EditAppendix8AForm data={appendix8AFormEdit} onClose={()=>setAppendix8AFormEdit(false)}/>}
            {enableIR8AForm && <IR8AForm onClose={(action) => closeIR8AForm()} data={ir8aformDetails} /> }
            {editIR8SForm && <EditIR8SForm data={editIR8SForm} onClose={()=>setEditIR8SForm(false)}/>}
            {enableAppendix8AForm && <Appendix8BForm onClose={() => {closeAppendix8BForm()}} data={appendix8BFormDetails} />}
        </>
    )

}

export default SGDefaultForms;
